import { NativeSelect, Pagination } from "@mantine/core";
import React, { useEffect } from "react";

function PaginationCardNew({ pagination, count }) {
  useEffect(() => {
    if (count) {
      pagination.setTotalItems(count);
    }
  }, [count]);

  return (
    <div className="d-flex justify-content-between">
      <div className="d-flex align-items-center gap-2">
        <NativeSelect
          value={pagination.pagesize}
          onChange={(event) => pagination.setPageSize(+event.target.value)}
          data={["15", "50", "100", "250", "500"]}
        />{" "}
        <div className="items-number">Total Items {count}</div>{" "}
      </div>
      <Pagination
        total={pagination.totalPages}
        onChange={pagination.setPage}
        // page={pagination.active}
        // styles={{
        //   item: {
        //     "&[data-active]": {
        //       background: "#404040",
        //     },
        //   },
        // }}
      />
    </div>
  );
}

export default PaginationCardNew;
